// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type DataPrivacyAgreementType = 'GOOGLE' | 'GOOGLE_GWG' | 'IBM';

export interface DataPrivacyAgreementsV1 {
  id: string;
  thirdPartyOrganizationId: string;
  programId?: string | null;
  userId: number;
  contractId: string;
  dpaType: DataPrivacyAgreementType;
  createdAt: number;
  deletedAt?: number | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface DataPrivacyAgreementsV1Connection {
  elements: Array<DataPrivacyAgreementsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface DataPrivacyAgreementsV1ByOrgQuery {
  DataPrivacyAgreementsV1: {
    byOrg: DataPrivacyAgreementsV1Connection | null;
  } | null;
}

export interface DataPrivacyAgreementsV1ByOrgQueryVariables {
  orgId: string;
  programId?: string | null;
  includes?: string | null;
}

export interface DataPrivacyAgreementsV1DeleteQuery {
  DataPrivacyAgreementsV1: {
    delete: DataPrivacyAgreementsV1Connection | null;
  } | null;
}

export interface DataPrivacyAgreementsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface DataPrivacyAgreementsV1GetQuery {
  DataPrivacyAgreementsV1: {
    get: DataPrivacyAgreementsV1Connection | null;
  } | null;
}

export interface DataPrivacyAgreementsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface DataPrivacyAgreementsV1CreateMutation {
  DataPrivacyAgreementsV1: {
    create: DataPrivacyAgreementsV1Connection | null;
  } | null;
}

export interface DataPrivacyAgreementsV1CreateMutationVariables {
  includes?: string | null;
}

export interface DataPrivacyAgreementsV1IsDPANeededMutation {
  DataPrivacyAgreementsV1: {
    isDPANeeded: DataPrivacyAgreementsV1Connection | null;
  } | null;
}

export interface DataPrivacyAgreementsV1IsDPANeededMutationVariables {
  orgId: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class DataPrivacyAgreementsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'dataPrivacyAgreements.v1' as const;

  declare id: string;

  declare thirdPartyOrganizationId: string;

  declare programId?: string | null;

  declare userId: number;

  declare contractId: string;

  declare dpaType: DataPrivacyAgreementType;

  declare createdAt: number;

  declare deletedAt?: number | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<DataPrivacyAgreementsV1>) {
    super(params);
  }
}
